import React from 'react'
import { Breadcrumb,   } from 'antd'
import {  HomeIcon, DocumentChartBarIcon,  } from "@heroicons/react/16/solid";
import LeavesTable from './LeavesTable';
const SickLeave = () => {
  const items = [
    {
      href: '/',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <HomeIcon className="h-6 w-6 text-gray-500" />
          <span className='text-gray-400 sm:text-lg'>Home</span>
        </span>
      ),
    },
    {
      href: '/sickleave',
      title: (
        <span className='flex sm:gap-2 items-center'>
          <DocumentChartBarIcon className="h-6 w-6 text-gray-300" />
          <span className='text-gray-400 sm:text-lg'> Add Leaves</span>
        </span>
      ),
    },
  ]
  return (
    <div >
      <span className='flex py-4 px-2 sm:p-10 flex-wrap gap-4 justify-between items-center '>
        <span className='flex flex-col gap-2 text-2xl  md:text-4xl font-black  dark:text-gray-100'>
        Add Leaves
          <Breadcrumb items={items} />
        </span>
      </span>
     {/* <LeaveForm/> */}
      <LeavesTable />
    </div>

  )
}

export default SickLeave